<template>
  <div class="memories-page">
    <!-- 顶部 -->
    <div class="top-header">
      <button class="back-btn" @click="$router.back()">返回</button>
      <img src="@/assets/suiyueyinji.webp" class="header-art-title" alt="岁月回忆录" />
    </div>

    <!-- 上半部 -->
    <div class="memorial-zone">
      <div class="mem-card big-card" v-if="memorialData.first"@click="goToDetailById(memorialData.first.id, memorialData.first.province, memorialData.first.city)">
        <img :src="memorialData.first.img" class="mem-img" />
        <div class="mem-info">
          <div class="mem-title">足迹初启</div>
          <div class="mem-desc">{{ memorialData.first.desc }}</div>
        </div>
      </div>

      <div class="mem-center-float">
        <div class="float-item"><span class="dot"></span>印记最多：{{ memorialData.mostCity }}</div>
        <div class="float-item"><span class="dot"></span>相伴最久：{{ memorialData.mostPartner }}</div>
        <div class="float-item"><span class="dot"></span>覆盖省份：{{ memorialData.provinceCount }} 个</div>
        <div class="float-item"><span class="dot"></span>点亮城市：{{ memorialData.cityCount }} 座</div>
      </div>

      <div class="mem-card big-card" v-if="memorialData.latest" @click="goToDetailById(memorialData.latest.id, memorialData.latest.province, memorialData.latest.city)">
        <img :src="memorialData.latest.img" class="mem-img" />
        <div class="mem-info">
          <div class="mem-title">最新足迹</div>
          <div class="mem-desc">{{ memorialData.latest.desc }}</div>
        </div>
      </div>
    </div>

    <!-- 👇 标签区：加上了 margin-top 往下移一点 -->
    <div class="tabs-center-wrap">
      <div class="tabs-wrap">
        <div class="tab-item" :class="{ active: currentTab === 'all' }" @click="switchTab('all')">全部</div>
        <div class="tab-item" :class="{ active: currentTab === 'personal' }" @click="switchTab('personal')">个人</div>
        <div v-for="g in groupList" :key="g.groupId" class="tab-item" :class="{ active: currentTab === g.groupId }" @click="switchTab(g.groupId)">{{ g.groupName }}</div>
      </div>
    </div>

    <!-- 下半部 -->
    <div class="timeline-zone">
      <div class="horizontal-line"></div>

      <div class="horizontal-scroll" ref="scrollContainer">
        <div class="timeline-node" v-for="(node, idx) in flattenedTimeline" :key="node.id">
          
          <!-- 日期区 -->
          <div class="node-date-wrap">
            <!-- 👇 只有 showDate 为 true 才显示文字 -->
            <div class="date-label" v-if="node.showDate">
              {{ node.year }}年{{ node.month }}月{{ node.day }}日
            </div>
            <div class="node-dot"></div>
          </div>
          
          <!-- 卡片区 -->
          <div class="node-card" @click="goToDetailById(node.id, node.province || '', node.city)">
            <div class="card-city">{{ node.city }}</div>
            <div class="card-detail">
              <span v-if="node.spots">景：{{ node.spots }}</span>
              <span v-if="node.food">食：{{ node.food }}</span>
              <span v-if="node.hotel">宿：{{ node.hotel }}</span>
              <span v-if="!node.spots && !node.food && !node.hotel" class="empty-text">自由漫步</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 👇 新增：大屏底部的走马灯照片墙 -->
      <div class="marquee-wall" v-if="allPhotos.length > 0">
        <div class="marquee-track">
          <!-- 第一组照片 -->
          <div class="marquee-group">
            <img 
              v-for="(img, idx) in allPhotos" 
              :key="'group-a-'+idx" 
              :src="img" 
              class="wall-img" 
              @click="previewPhoto(img)"
            />
          </div>
          <!-- 第二组照片（用于无缝滚动） -->
          <div class="marquee-group">
            <img 
              v-for="(img, idx) in allPhotos" 
              :key="'group-b-'+idx" 
              :src="img" 
              class="wall-img" 
              @click="previewPhoto(img)"
            />
          </div>
        </div>
      </div>
      <!-- 👇 新增：底部左右滑动提示 -->
      <div class="scroll-hint">
        <span class="hint-arrow">◀</span> 左右滑动查看岁月时光 <span class="hint-arrow">▶</span>
      </div>
    </div>
    <div class="photo-preview-mask" v-if="previewImg" @click="previewImg = ''">
      <img :src="previewImg" class="preview-big-img" @click.stop />
    </div>
    <div v-if="rawFootprints.length === 0" class="empty-mask"></div>
    <!-- 空数据专属提示弹窗 -->
    <div v-if="showEmptyTipPopup" class="tip-mask" @click="goBackHome">
      <div class="tip-panel" @click.stop>
        <div class="tip-text">你还没有足迹印记，无法生成《岁月长卷》，<br>欢迎你登记足迹后再来。</div>
        <button class="tip-btn" @click="goBackHome">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getFootprintList, getMyGroupList } from '@/api/footprint'
// 引入默认图池
import defCover1 from '@/assets/defaults/def-cover-1.jpg'
import defCover2 from '@/assets/defaults/def-cover-2.jpg'
import defFood from '@/assets/defaults/def-food.jpg'
import defHotel from '@/assets/defaults/def-hotel.jpg'
import defScene1 from '@/assets/defaults/def-scene-1.jpg'
import defScene2 from '@/assets/defaults/def-scene-2.jpg'

export default {
  name: 'Memories',
  data() {
    return {
      rawFootprints: [],
      groupList: [],
      currentTab: 'all',
      defaultImgs: [defCover1, defCover2, defFood, defHotel, defScene1, defScene2],
      previewImg: '',
      showEmptyTipPopup: false,
    }
  },
  computed: {
    filteredFootprints() {
      if (this.currentTab === 'all') return this.rawFootprints
      if (this.currentTab === 'personal') return this.rawFootprints.filter(f => !f.belongGroupId)
      return this.rawFootprints.filter(f => f.belongGroupId === this.currentTab)
    },
    memorialData() {
      if (this.filteredFootprints.length === 0) return {};

      const sorted = [...this.filteredFootprints].sort((a,b) => new Date(a.arriveTime) - new Date(b.arriveTime));
      const first = sorted[0];
      const latest = sorted[sorted.length - 1];

      // 统计最爱城市与同行人
      const cityCount = {};
      this.filteredFootprints.forEach(f => { if(f.city) cityCount[f.city] = (cityCount[f.city] || 0) + 1 });
      const mostCity = Object.keys(cityCount).sort((a,b) => cityCount[b] - cityCount[a])[0];

      const partnerCount = {};
      this.filteredFootprints.forEach(f => { if(f.partner) partnerCount[f.partner] = (partnerCount[f.partner] || 0) + 1 });
      const mostPartner = Object.keys(partnerCount).sort((a,b) => partnerCount[b] - partnerCount[a])[0];

      return {
        first: {
          id: first.id,                 
          province: first.province,       
          city: first.city,
          desc: `${first.arriveTime.substring(0, 7)}，你在「${first.city}」留下了第一条印记。`,
          img: (first.photoList && first.photoList[0]) || this.defaultImgs[0]
        },
        latest: {
          id: latest.id,                  
          province: latest.province,      
          city: latest.city, 
          desc: `最近一次，你与所爱之人在「${latest.city}」珍藏了时光。`,
          img: (latest.photoList && latest.photoList[0]) || this.defaultImgs[1]
        },
        mostCity: mostCity ? `「${mostCity}」去了 ${cityCount[mostCity]} 次` : '足迹还在延续',
        mostPartner: mostPartner ? `与「${mostPartner}」同行 ${partnerCount[mostPartner]} 次` : '期待下一次同行',
        provinceCount: [...new Set(this.filteredFootprints.map(f => f.province))].length,
        cityCount: [...new Set(this.filteredFootprints.map(f => f.city))].length
      };
    },
    flattenedTimeline() {
      // 直接对原始记录排序（按时间倒序）
      const sorted = [...this.filteredFootprints].sort((a, b) => {
        const dateA = new Date(a.arriveTime || a.createTime);
        const dateB = new Date(b.arriveTime || b.createTime);
        return dateB - dateA;
      });

      let lastDateStr = ''; // 用于控制同一天的日期是否只显示一次

      return sorted.map(item => {
        const dateStr = item.arriveTime || item.createTime;
        if (!dateStr) return null;
        
        let year, month, day, dateKey;
        if (typeof dateStr === 'number') {
          const d = new Date(dateStr);
          year = d.getFullYear(); month = d.getMonth() + 1; day = d.getDate();
          dateKey = `${year}-${month}-${day}`;
        } else {
          year = parseInt(String(dateStr).substring(0, 4));
          month = parseInt(String(dateStr).substring(5, 7));
          day = parseInt(String(dateStr).substring(8, 10)) || 1;
          dateKey = `${year}-${month}-${day}`;
        }

        // 👇 判断是否显示日期（同一天只显示第一个日期）
        let showDate = false;
        if (dateKey !== lastDateStr) {
          showDate = true;
          lastDateStr = dateKey;
        }

        return {
          id: item.id, // 每一条记录唯一 ID
          year, month, day,
          showDate,
          city: item.city,
          spots: item.spots,
          food: item.food,
          hotel: item.hotel
        };
      }).filter(Boolean); // 过滤掉空数据
    },
    // 联动标签获取照片，无图则用默认图兜底
    allPhotos() {
      let photos = [];
      this.filteredFootprints.forEach(f => {
        if (f.photoList && f.photoList.length) {
          photos = photos.concat(f.photoList);
        }
      });
      
      // 👇 核心：如果没有任何真实照片，直接返回系统默认图库
      if (photos.length === 0) {
        return this.defaultImgs; 
      }
      if (photos.length < 6) {
        let temp = [...photos];
        while (temp.length < 10) { temp = temp.concat(photos); }
        return temp;
      }
      
      return photos;
    }
  },

async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const [foots, groups] = await Promise.all([ getFootprintList(), getMyGroupList() ])
        this.rawFootprints = foots || []
        this.groupList = groups || []
        if (this.rawFootprints.length === 0) {
          this.showEmptyTip();
        }
      } catch (err) { console.error("获取失败", err) }
    },
    previewPhoto(url) {
      this.previewImg = url;
    },

    showEmptyTip() {
      this.showEmptyTipPopup = true;
    },
    goBackHome() {
      this.showEmptyTipPopup = false;
      this.$router.replace('/personal-center');
    },
    // 给上下两个玻璃方块用的跳转
    goToDetailById(id, province, city) {
      if (!id) return;
      this.$router.push({
        path: '/detail',
        query: { id, province, city }
      });
    },
    
    // 给时间轴卡片用的跳转
    goToDetail(node) {
      const firstItem = node.items[0];
      if (!firstItem || !firstItem.id) return;
      this.$router.push({
        path: '/detail',
        query: { id: firstItem.id, province: firstItem.province, city: firstItem.city }
      });
    },    switchTab(tabId) {
      this.currentTab = tabId;
      // 切换标签时，横向滚动条回到最左边
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollLeft = 0;
      }
    }
  }
}
</script>

<style scoped>
/* ============================================================
   全局骨架
   ============================================================ */
.memories-page {
  width: 100vw; height: 100vh;
  background-image: url("~@/assets/suiyue.webp"); 
  background-repeat: repeat; background-size: cover; background-position: center;
  display: flex; flex-direction: column; overflow: hidden; position: relative;
}

/* ============================================================
   1. 顶部
   ============================================================ */
.top-header {
  position: relative; flex-shrink: 0;
  height: clamp(40px, 6vh, 56px);
  padding: 0; 
  display: flex; justify-content: center;
  z-index: 100;
}
.back-btn {
  position: absolute; 
  top: 50%;
  transform: translateY(-50%);
  left: clamp(16px, 3vw, 24px);
  
  /* 👇 完美复刻：极致小巧白玉胶囊的黄金标准 */
  height: clamp(24px, 3.2vh, 28px);
  padding: 0 clamp(8px, 1.2vw, 14px);
  
  border-radius: 6px; 
  display: inline-flex; 
  align-items: center; 
  justify-content: center;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.15));
  color: #fff; 
  font-weight: 600; 
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 
    0 2px 6px rgba(0, 0, 0, 0.1), 
    inset 0 2px 4px rgba(255, 255, 255, 0.9), 
    inset 0 -2px 4px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(8px);
  font-size: clamp(11px, 1.1vw, 14px);
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s ease;
  text-shadow: 0 1px 2px rgba(255,255,255,0.5);
}
.header-art-title {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* 👇 把高度上限调大：原来最大是 40px，现在改到 60px，甚至 70px */
  height: clamp(55px, 8.5vh, 85px); 
  width: auto;
  }

/* ============================================================
   2. 上半部
   ============================================================ */
.memorial-zone {
  flex-shrink: 0;
  height: clamp(100px, 32vh, 260px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 clamp(20px, 5vw, 60px);
  box-sizing: border-box;
  gap: clamp(8px, 1.5vw, 16px);
}

.mem-card {
  cursor: pointer;
  background: rgba(255,255,255,0.4); backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255,255,255,1); border-radius: 16px;
  padding: 12px; height: 100%; max-height: clamp(100px, 26vh, 180px);
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.08),           
    inset 0 2px 4px rgba(255, 255, 255, 0.6), 
    inset 0 -2px 4px rgba(255, 255, 255, 0.2);
  display: flex; gap: 12px; align-items: center;
  flex: 1 1 30%;
  min-width: 0;
}

.mem-img { width: clamp(80px, 35%, 160px); height: 100%; object-fit: cover; border-radius: 10px; flex-shrink: 0; }
.mem-info { flex: 1; display: flex; flex-direction: column; justify-content: center; min-width: 0; }
.mem-title { font-size: clamp(13px, 1.4vw, 16px); font-weight: bold; color: #2c3e50; margin-bottom: 4px; }
.mem-desc { font-size: clamp(11px, 1vw, 13px); color: #555; line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }

.mem-center-float {
  flex: 0 1 35%; 
  min-width: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(6px, 1vh, 10px) clamp(10px, 1.6vw, 16px); 
  padding: 0 clamp(4px, 1vw, 10px);
}
.float-item {
  min-width: 0;
  overflow: hidden; 
  font-size: clamp(10px, 0.8vw, 12px);
  color: #444; font-weight: bold;
  display: flex; align-items: flex-start; line-height: 1.4;
}
.float-item .dot {
  display: inline-block; width: 6px; height: 6px;
  background: #c49a37; border-radius: 50%;
  margin-right: 6px; flex-shrink: 0; margin-top: 5px;
}

/* ============================================================
   3. 标签区：下移稍微一点
   ============================================================ */
.tabs-center-wrap {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  padding: clamp(4px, 1vh, 12px) 0;
  margin-top: 5px; 
  z-index: 50;
  width: 100%;
}
.tabs-wrap { 
  display: flex; 
  gap: 8px; 
  max-width: 95vw;                    
  overflow-x: auto;                    
  scrollbar-width: none; 
  padding: 0 10px;
}
.tabs-wrap::-webkit-scrollbar { display: none; }
.tab-item { 
  height: clamp(24px, 3.2vh, 28px);
  padding: 0 clamp(4px, 0.8vw, 10px);
  border-radius: 6px; 
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: clamp(11px, 1.1vw, 14px); 
  font-weight: 600; 
  color: #555; 
  cursor: pointer; 
  background: rgba(255,255,255,0.6); 
  border: 1px solid rgba(255,255,255,0.9); 
  transition: all 0.3s;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.tab-item.active { 
  background: #d6486b; 
  color: #fff; 
  border-color: #d6486b; 
  box-shadow: 0 2px 6px rgba(214, 72, 107, 0.3); 
}

/* ============================================================
   4. 下半部
   ============================================================ */
.timeline-zone {
  flex: 1; 
  position: relative; 
  display: flex; 
  flex-direction: column; 
  overflow: hidden; 
  --line-pos: 22%;
}

.horizontal-line {
  position: absolute;
  top: var(--line-pos);
  left: 0; width: 100%; height: 3px;
  background: rgba(196, 154, 55, 0.7);
  z-index: 0;
}

.horizontal-scroll {
  display: flex; gap: clamp(16px, 2vw, 30px); 
  padding: 0 20px;
  overflow-x: auto; scroll-snap-type: x mandatory; scrollbar-width: none;
  height: 100%; z-index: 2;
  flex: 1; 
  align-items: flex-start; /* 顶部对齐，避免往下滑 */
}
.horizontal-scroll::-webkit-scrollbar { display: none; }

.timeline-node {
  flex-shrink: 0; display: flex; flex-direction: column; align-items: center;
  scroll-snap-align: center; height: 100%;
}

/* 日期区 */
.node-date-wrap {
  position: relative;
  width: 100%;
  height: var(--line-pos);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 4px;
}

.date-label {
  font-size: clamp(9px, 0.6vw, 11px);
  color: #c49a37;
  font-weight: bold;
  margin-bottom: 10px;
  white-space: nowrap;
}

.node-dot {
  position: absolute;
  bottom: -6px; 
  width: 12px; height: 12px; 
  background: #d6486b; 
  border: 3px solid #F7F3E9; 
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(214,72,107,0.3); 
  animation: pulse 2s infinite; z-index: 5;
}
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(214, 72, 107, 0.8); }
  70% { box-shadow: 0 0 0 10px rgba(214, 72, 107, 0); }
  100% { box-shadow: 0 0 0 0 rgba(214, 72, 107, 0); }
}

/* 👇 卡片整体往下推一点 */
.node-card {
  cursor: pointer;
  width: clamp(140px, 14vw, 220px); 
  background: rgba(255,255,255,0.9);
  border-radius: 8px; padding: 12px; 
  min-height: 75px; 
  /* 增加 margin-top，整体下移 5px */
  margin-top: 20px; 
  
  border-left: 3px solid #c49a37; box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  text-align: left; display: flex; flex-direction: column;
}

.card-city { 
  font-size: clamp(10px, 0.95vw, 12px); 
  font-weight: bold; color: #111; 
  margin-bottom: 6px; border-bottom: 1px dashed #ddd; padding-bottom: 3px; 
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;min-height: 20px;
}

.card-detail { 
  display: flex;
  flex-direction: column;
  gap: 4px; /* 行与行之间稍微拉开一点点距离 */
  overflow: hidden; /* 防止内容过多溢出卡片 */
  font-size: clamp(9px, 0.8vw, 10px); 
  color: #777; line-height: 1.3; word-break: break-all; 
}

/* 强制每个 span 独占一行，并且超出显示省略号 */
.card-detail span {
  display: -webkit-box;
  -webkit-line-clamp: 1; /* 每项最多显示1行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.empty-text { color: #aaa; font-style: italic; }

/* ============================================================
   5. 左右滑动提示
   ============================================================ */
.scroll-hint {
  /* 👇 删除了 position, bottom, left, transform */
  flex-shrink: 0; /* 保证文字不被压扁 */
  padding-bottom: clamp(6px, 2vh, 16px); /* 距离底部的边距 */
  padding-top: 8px; /* 距离上方卡片的距离 */
  font-size: clamp(9px, 0.9vw, 11px); 
  color: #999;
  font-weight: bold;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center; /* 居中 */
  gap: 6px;
  pointer-events: none;
  z-index: 10; 
 animation: blinkFlow 1.5s infinite ease-in-out !important;
}

.hint-arrow {
  /* 👇 继承字号，不再单独设大字号 */
  font-size: 1em; 
  color: #c49a37;
}

@keyframes breathe {
  0%, 100% { opacity: 0.6; transform: translateX(-50%) scale(1); }
  50% { opacity: 1; transform: translateX(-50%) scale(1.02); }
}
/* ============================================================
   大屏专属：底部走马灯照片墙
   ============================================================ */
/* 默认（手机端）隐藏照片墙 */
.marquee-wall { display: none; }

/* 大图预览遮罩层（全端通用，点击时出现） */
.photo-preview-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
  cursor: zoom-out;
  animation: fadeIn 0.2s ease;
}
.preview-big-img {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.5);
  cursor: default;
  animation: zoomIn 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes zoomIn { from { transform: scale(0.9); opacity: 0; } to { transform: scale(1); opacity: 1; } }

/* 只在屏幕高度大于 700px 时才生效 */
@media (min-height: 700px) {
  .marquee-wall {
    display: block;
    position: fixed;
    bottom: 30px; 
    left: 0;
    width: 100vw;
    height: clamp(120px, 20vh, 180px); 
    overflow: hidden;
    z-index: 10;
    /* 边缘羽化效果 */
    -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
    mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
  }

  .marquee-track {
    display: flex;
    height: 100%;
    width: max-content;
    animation: scrollMarquee 30s linear infinite; 
    flex-shrink: 0;
  }

  /* 👇 新增：把两组图片包起来 */
  .marquee-group {
    display: flex;
    gap: 16px;
    padding-right: 16px; /* 组与组之间留一点空隙，不然会粘连 */
    height: 100%;
  }

  .marquee-wall:hover .marquee-track { 
    animation-play-state: paused; 
  }

  /* 👇 修复裂图与变形 */
  .wall-img {
    /* 锁死宽高，避免 flex 挤压造成的裂图 */
    width: 200px; /* 可以根据你喜欢的卡片大小调整，或写 clamp */
    height: 100%;
    object-fit: cover;
    
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    border: 2px solid rgba(255,255,255,0.8);
    cursor: pointer;
    transition: transform 0.2s;
    
    /* 防止本地图片因为异步加载闪烁 */
    background-color: rgba(0, 0, 0, 0.05); 
  }
  
  .wall-img:hover {
    transform: translateY(-4px) scale(1.02);
    border-color: #c49a37; /* 悬浮时加上金色边框呼应主题 */
  }

  /* 调整滑动提示的位置（往上抬，避开照片墙） */
  .scroll-hint {
    position: absolute;
    bottom: calc(clamp(120px, 20vh, 180px) + 40px);  
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 0;
    padding-bottom: 0;
    z-index: 20; 
    animation: blinkAbsolute 1.5s infinite ease-in-out !important;
  }

  .timeline-zone {
    padding-bottom: 0; 
    height: 55vh; 
  }
}

@keyframes scrollMarquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); } 
}
/* 手机端闪烁 */
@keyframes blinkFlow {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
}

/* 大屏端闪烁（保持居中，只闪透明度） */
@keyframes blinkAbsolute {
  0%, 100% { opacity: 0.3; transform: translateX(-50%); }
  50% { opacity: 1; transform: translateX(-50%); }
}
.empty-mask {
  position: absolute;
  inset: 0;
  background: transparent;
  backdrop-filter: blur(6px); 
 -webkit-backdrop-filter: blur(6px);
  z-index: 90; 
  pointer-events: none; 
}
/* ============================================================
   空数据专属提示弹窗（提取自个人中心，已去重精简）
   ============================================================ */
.tip-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.32);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tip-panel {
  min-width: clamp(200px, 60vw, 280px);
  max-width: 320px;
  padding: clamp(16px, 2.5vh, 24px) clamp(20px, 3vw, 32px);
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 420px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.98);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
  
  /* flex 排版 */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(12px, 2vh, 20px);
}

.tip-panel .tip-text {
  font-size: clamp(13px, 1.3vw, 15px) !important;
  color: #383838 !important;
  line-height: 1.5;
  margin-bottom: 0 !important;
  text-align: center;
  font-family: "Microsoft YaHei", sans-serif;
  word-break: break-all;
}

.tip-panel .tip-btn {
  padding: clamp(4px, 0.8vh, 6px) clamp(20px, 3vw, 32px);
  font-size: clamp(12px, 1.2vw, 14px);
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.25), transparent 50%), rgba(209, 74, 74, 0.85);
  box-shadow: 0 3px 8px rgba(209, 74, 74, 0.2), inset 0 1px 2px rgba(255, 255, 255, 0.5);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.tip-panel .tip-btn:hover {
  transform: translateY(-1px);
}

.tip-panel .tip-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>